export default __webpack_public_path__ + "static/media/10.60678ba1.jpg";